import Reveal from "@/components/base/Reveal";

const steps = [
  {
    icon: "ri-message-3-line",
    title: "1. Chama no WhatsApp",
    desc: "Responde umas perguntas rápidas. A gente entra em contato em minutos.",
  },
  {
    icon: "ri-shield-keyhole-line",
    title: "2. Liberação da BM",
    desc: "Preparamos e liberamos sua Business Manager pro Kwai Ads.",
  },
  {
    icon: "ri-rocket-line",
    title: "3. Sobe a campanha",
    desc: "Te ensinamos o passo a passo pra subir o primeiro anúncio.",
  },
];

export default function BioHowItWorks() {
  return (
    <section id="como-funciona" className="py-16 md:py-20 px-4">
      <div className="max-w-lg mx-auto">
        <Reveal>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-center text-foreground-950 mb-10">
            Como funciona
          </h2>
        </Reveal>

        <div className="space-y-6">
          {steps.map((step, i) => (
            <Reveal key={step.title} delay={i * 100}>
              <div className="flex items-start gap-4 rounded-xl border border-background-300/30 bg-background-100/50 p-5">
                <div className="w-10 h-10 rounded-lg bg-primary-500/15 flex items-center justify-center shrink-0">
                  <i className={`${step.icon} text-primary-400 text-lg`}></i>
                </div>
                <div>
                  <h3 className="font-semibold text-foreground-950 mb-1">{step.title}</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">{step.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}